<div class="d-flex flex-column">
    <div class="w-33 mx-auto">
        <span class="p-float-label mt-4">
            <input pInputText #validationCodeInput name="validationCodeInput" type="text" [(ngModel)]="validationCode" autocomplete="one-time-code"
                class="w-100 text-center" />
            <label for="validationCodeInput">Validation Code</label>
        </span>
        <p-button pRipple styleClass="p-button-raised p-button-info m-2" (click)="onSignIn()">
            <ng-template pTemplate="content">
                <div class="d-flex justify-content-center">
                    <fa-icon [icon]='["far","sign-in-alt"]' size="lg" class="ms-1 me-2"></fa-icon>
                    Sign in
                </div>
            </ng-template>
        </p-button>
    </div>
    
</div>